import { c as _c } from "react/compiler-runtime";
import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import { useFormAction } from '@repo/platform-analytics/hooks/useFormAction';
import { CARDFINDER_FLOW_NAME } from '@/shared/config/funnel/flowConstants';
import { getFieldType, serializeActionInput } from '../lib/analytics';
export function useFunnelFormAction() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      formName: CARDFINDER_FLOW_NAME,
      sectionName: "cardfinder_funnel"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fireFormAction = useFormAction(t0);
  let t1;
  if ($[1] !== fireFormAction) {
    t1 = (stepId, branchId, submittedAnswer) => {
      fireFormAction({
        formAction: "step-submitted",
        stepName: stepId,
        field: stepId,
        fieldType: getFieldType(submittedAnswer),
        fieldValue: serializeActionInput(submittedAnswer),
        additionalAttributes: {
          page_branch_name: branchId
        }
      });
    };
    $[1] = fireFormAction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}